<template>
  <div>
    <template v-for="(value, key) in fields">
      <template v-if="isNested(value)">
        <HiddenFormFields
          v-if="valueItemsCount(value) > 0"
          :fields="value"
          :name-prefix="fieldNameFull(key)"
        />
        <input
          v-else
          type="hidden"
          :name="fieldNameFull(key)"
        >
      </template>
      <input
        v-else
        type="hidden"
        :name="fieldNameFull(key)"
        :value="value"
      >
    </template>
  </div>
</template>

<script>
  export default {
    name: 'HiddenFormFields',
    props: {
      fields: {
        type: [Object, Array],
        required: true,
      },
      namePrefix: {
        type: String,
        default: '',
      }
    },
    methods: {
      isNested(value) {
        return (
          typeof value === 'object'
          &&
          value !== null
        );
      },
      valueItemsCount(value) {
        return Array.isArray(value)
          ? value.length
          : Object.keys(value).length;
      },
      fieldNameFull(fieldName) {
        return this.namePrefix
          ? `${this.namePrefix}[${fieldName}]`
          : fieldName;
      },
    },
  }
</script>
